export default __webpack_public_path__ + "static/media/a026-example4.77543089.jpg";